import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export function ResourceForm({ open, onClose, spec, resource, initial, onSubmit, busy, color }) {
  const [data, setData] = useState({});
  const [guardError, setGuardError] = useState("");
  useEffect(() => {
    const base = {};
    spec.fields.forEach((f) => { base[f.key] = initial?.[f.key] ?? (f.type === "bool" ? false : f.type === "select" ? f.options[0] : ""); });
    setData(base);
  }, [initial, spec, open]);

  const set = (k, v) => { setGuardError(""); setData((d) => ({ ...d, [k]: v })); };
  const submit = () => {
    if (resource === "transactions") {
      const amount = Number(data.amount);
      if (!Number.isFinite(amount) || amount <= 0) return setGuardError("حارس الواجهة: أدخل مبلغاً موجباً وصالحاً.");
      if (!["SAR", "USD", "EUR", "AED"].includes(data.currency)) return setGuardError("حارس الواجهة: اختر عملة مدعومة.");
    }
    setGuardError("");
    onSubmit(data);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-950 border-slate-800 text-slate-100 max-w-lg max-h-[90vh] overflow-y-auto" dir="rtl" data-testid={`resource-form-${resource}`}>
        <DialogHeader>
          <DialogTitle className="text-right" style={{ color }}>{initial ? "تعديل" : "إضافة"} — {spec.name}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-2 sm:grid-cols-2">
          {spec.fields.map((f) => {
            const wide = f.type === "textarea";
            const id = `field-${resource}-${f.key}`;
            return (
              <div key={f.key} className={`space-y-1.5 ${wide ? "sm:col-span-2" : ""}`}>
                <Label htmlFor={id} className="text-xs text-slate-400">{f.label}{f.required && <span className="text-red-400"> *</span>}</Label>
                {f.type === "textarea" && <Textarea id={id} data-testid={id} value={data[f.key] ?? ""} onChange={(e) => set(f.key, e.target.value)} rows={3} className="bg-slate-900 border-slate-800" />}
                {f.type === "select" && (
                  <select id={id} data-testid={id} value={data[f.key] ?? ""} onChange={(e) => set(f.key, e.target.value)} className="dark-select">
                    {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
                  </select>
                )}
                {f.type === "bool" && (
                  <div className="h-10 flex items-center"><Switch id={id} data-testid={id} checked={!!data[f.key]} onCheckedChange={(v) => set(f.key, v)} /></div>
                )}
                {["text", "number", "date", "datetime"].includes(f.type) && (
                  <Input id={id} data-testid={id} type={f.type === "datetime" ? "datetime-local" : f.type} value={data[f.key] ?? ""} onChange={(e) => set(f.key, e.target.value)} className="bg-slate-900 border-slate-800" />
                )}
              </div>
            );
          })}
        </div>
        {resource === "transactions" && <p className="text-[11px] text-slate-400">بوابة الدفع الأمامية: حارسان للتحقق من المبلغ والعملة.</p>}
        {guardError && <p role="alert" className="border border-rose-400/30 bg-rose-400/10 px-3 py-2 text-xs text-rose-200">{guardError}</p>}
        <DialogFooter className="gap-2 sm:justify-start">
          <Button data-testid={`resource-form-submit-${resource}`} onClick={submit} disabled={busy} className="text-slate-950 font-semibold" style={{ background: color }}>
            {busy ? "جارٍ الحفظ..." : "حفظ"}
          </Button>
          <Button data-testid={`resource-form-cancel-${resource}`} variant="ghost" onClick={onClose}>إلغاء</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
